/**
 * Which "nothing here" banners the Meetings tab shows under the sessions table.
 *
 * Both banners are for an empty tab only. A student with no CSOC subscription
 * (csoc_subscription_status -1) or an upcoming one (3) can still have sessions
 * listed — e.g. a cover-up session booked by ops — and must not see
 * "Enroll in School of Chess" / "Your classes will appear here soon" under them.
 * The expired "Renew" prompt is not decided here: it stays visible under past rows.
 */
export type MeetingsEmptyStateInput = {
  rowCount: number | undefined;
  expired?: number;
  csocStatus?: number;
};

export const meetingsEmptyState = ({
  rowCount,
  expired,
  csocStatus,
}: MeetingsEmptyStateInput) => {
  const empty = !(Number(rowCount) > 0);
  return {
    showEmptyView: empty && (expired === 0 || csocStatus === -1),
    showClassesComingSoon: empty && csocStatus === 3,
  };
};
